import {useMemo} from 'react';
import {USER_ROLES} from 'common/components/permissions/constants';
import useUserStore from 'common/stores/user';

// interface UserRoles {
//     isAdmin?: boolean;
//     isBmo?: boolean;
//     isLargeAccount?: boolean;
//     isCustomerService?: boolean;
//     isMrc: boolean;
//     isKsUser?: boolean;
//     isKsAdmin?: boolean;
// }

export function useUserRoles() {
	const roles = useUserStore((state) => state.user?.roles);

	return useMemo(() => {
		const has = (role: string) => roles?.includes(role) ?? false;
		return {
			isAdmin:           has(USER_ROLES.ADMIN),
			isBmo:             has(USER_ROLES.BMO),
			isLargeAccount:    has(USER_ROLES.LARGEACC),
			isCustomerService: has(USER_ROLES.CUSTOMER_SERVICE),
			isMrc:             has(USER_ROLES.MRC),
			isKsUser:          has(USER_ROLES.KS_USER),
			isKsAdmin:         has(USER_ROLES.KS_ADMIN),
			// The backend's /threesixty/userconfig endpoints require the customer service role,
			// so other users can neither load nor save settings.
			canUseUserConfig:  has(USER_ROLES.CUSTOMER_SERVICE),
		};
	}, [roles]);
}